import React from 'react'

export default function Filenotfound() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 47 59" width="3rem" class="hero_utility-page_icon"><path fill-rule="evenodd" d="M0 0H30.5L47 16.5V59H0V0ZM21 19H26V34H21V19ZM21 39H26V44H21V39Z" fill="currentColor"></path></svg>
    )
}
